<template>
    <div class="university-detail">
        <achiTitle title="区内高校院所一览" subtitle="链接高校优质资源，促进学术交流与转化"></achiTitle>

        <!-- 加载状态 -->
        <el-loading v-if="loading" fullscreen text="正在加载学校详情..."></el-loading>

        <!-- 错误提示 -->
        <el-alert v-if="error" title="数据加载失败" :description="error" type="error" show-icon
            class="error-alert"></el-alert>

        <!-- 学校详情内容 -->
        <div v-if="university && !loading && !error" class="detail-container">
            <!-- 头部信息 -->
            <div class="header-section">
                <div class="logo-container">
                    <img :src="university.logo" :alt="university.name + '校徽'" class="logo-img"
                        @error="handleImageError">
                </div>
                <div class="info-header">
                    <h1 class="university-title">{{ university.name }}</h1>
                    <div class="basic-info">
                        <div class="info-item">
                            <i class="el-icon-map-marker"></i>
                            <span>学校地址:{{ university.region }}</span>
                        </div>
                        <div class="info-item">
                            <i class="el-icon-phone"></i>
                            <span>联系电话：{{ university.phone }}</span>
                        </div>
                        <div class="info-item">
                            <i class="el-icon-user"></i>
                            <span>专家人数: {{ university.technicalExperts.length }}</span>
                        </div>
                        <div class="info-item">
                            <i class="el-icon-link"></i>
                            <a :href="university.officialWebsite" target="_blank">官方网站：{{ university.officialWebsite
                            }}</a>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 轮播图区域 -->
            <div class="carousel-section">
                <el-carousel height="450px" indicator-position="outside">
                    <el-carousel-item v-for="(img, index) in university.introductionImages" :key="index">
                        <img :src="img" :alt="university.name + '校园风光' + (index + 1)" class="carousel-img">
                    </el-carousel-item>
                </el-carousel>
            </div>

            <!-- 学校介绍 -->
            <div class="introduction-section">
                <h2 class="section-title">学校介绍</h2>
                <div class="introduction-content">
                    <!-- 将换行符转换为<br>标签 -->
                    <p v-for="(paragraph, index) in introductionParagraphs" :key="index">
                        {{ paragraph }}
                    </p>
                </div>
            </div>
            <!--相关专家-->
            <div class="experts-section" v-if="university.experts && university.experts.length > 0">
                <h2 class="section-title">技术专家</h2>
                <el-row :gutter="20">
                    <el-col :xs="24" :sm="12" :md="8" v-for="expert in university.experts" :key="expert.id">
                        <expertItem :expert="expert" />
                    </el-col>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>
import expertItem from './expertItem.vue';
export default {
    props: {
        id: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            university: null,
            loading: true,
            error: null,
            allUniversities: []
        };
    },
    components:{expertItem},
    computed: {
        // 将介绍文本按换行符分割成段落
        introductionParagraphs() {
            if (!this.university || !this.university.introduction) return [];
            return this.university.introduction.split('\n').filter(p => p.trim() !== '');
        }
    },
    mounted() {
        this.loadUniversityDetail(this.id);
    },
    methods: {
        async loadUniversityDetail(id) {
            try {
                this.loading = true;
                // 加载所有学校数据
                const response = await this.$httpTemp.get('/mock/shenyang_universities.json');
                this.allUniversities = response;
                const found = this.allUniversities.find(item => item.id === this.id);
                // 加载专家数据
                const expertResponse = await this.$httpTemp.get('/mock/technical_experts.json');
                this.allExperts = expertResponse;
                // 查找匹配ID的学校
                if (found) {
                    this.university = found;
                    console.log
                    this.error = null;
                    // 关联专家数据
                    found.experts = found.technicalExperts.map(id =>
                        this.allExperts.find(exp => exp.id === id)
                    ).filter(Boolean);

                } else {
                    this.error = '未找到指定的学校信息';
                }
            } catch (err) {
                this.error = '数据加载失败，请稍后重试';
                console.error('加载学校详情出错:', err);
            } finally {
                this.loading = false;
            }
        },
        handleImageError(e) {
            // 校徽加载失败时使用默认图片
            e.target.src = 'https://picsum.photos/200/200?grayscale';
        }
    }
};
</script>

<style scoped>
.university-detail {
    max-width: 1200px;
    margin: 0 auto;
    padding: 30px;
}

.error-alert {
    margin-bottom: 20px;
}

.detail-container {
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    padding: 30px;
}

.header-section {
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    flex-wrap: wrap;
    gap: 20px;
}

.logo-container {
    width: 150px;
    height: 150px;
    border-radius: 50%;
    overflow: hidden;
    border: 4px solid #f5f5f5;
    flex-shrink: 0;
}

.logo-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.info-header {
    flex-grow: 1;
}

.university-title {
    margin: 0 0 20px 0;
    color: #333;
    font-size: 28px;
    font-weight: 700;
}

.basic-info {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    color: #666;
}

.info-item {
    display: flex;
    align-items: center;
    font-size: 16px;
}

.info-item i {
    margin-right: 8px;
    color: #409eff;
}

.info-item a {
    color: #409eff;
    text-decoration: none;
}

.info-item a:hover {
    text-decoration: underline;
}

.carousel-section {
    margin-bottom: 40px;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.carousel-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.introduction-section {
    line-height: 1.8;
}

.section-title {
    font-size: 22px;
    color: #333;
    padding-bottom: 10px;
    border-bottom: 2px solid #f0f0f0;
    margin-bottom: 20px;
}

.introduction-content {
    color: #555;
    font-size: 16px;
}

.introduction-content p {
    margin-bottom: 16px;
    text-align: justify;
}

/* 响应式调整 */
@media (max-width: 768px) {
    .header-section {
        flex-direction: column;
        text-align: center;
    }

    .basic-info {
        justify-content: center;
    }

    .carousel-section {
        margin-bottom: 20px;
    }

    .el-carousel {
        height: 250px !important;
    }
}
</style>
